<script>
  import { onMount } from 'svelte';
  import { push } from 'svelte-spa-router';

  onMount(() => {
    push('/');
  });
</script>

<div>Her har det skjedd en feil. Prøv å laste inn siden på nytt!</div>
